import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL;

export const getEquipments = async (page: number, filters: any) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/equipments`, { params: {page, size: 10, ...filters },
            withCredentials: true
        });

        const transformedEquipments = response.data.data.equipments.content.map((item: any) => ({
            PLANTA: item.plantUniqueCode,
            CLIENTE: item.clientUniqueCode,
            DOSIFICADOR: item.dispenserUniqueCode,
            ADITIVO: item.additiveUniqueCode,
            ID: item.id
        }));

        return {
            equipments: transformedEquipments || [],
            page: response.data.data.equipments.number,
            totalPages: response.data.data.equipments.totalPages,
        }

    } catch (error) {
        throw error;
    }
}

export const getComponentsForEquipments = async () => {
    try{
        const response = await axios.get(`${API_BASE_URL}/equipments/components`, {withCredentials: true});
        return {
            components: response.data.data.components,
            additives: response.data.data.additives,
            clients: response.data.data.clients
        }
    }
    catch(error){
        throw error;
    }
}

export const saveEquipment = async (equipmentDTO: any) => {
    try{
        const response = await axios.post(`${API_BASE_URL}/equipments`, equipmentDTO , {withCredentials: true});
        return response;
    }
    catch(error){
        console.error(error);
        throw error;
    }
}

export const getEquipmentByUniqueCode = async (equipmentId: number) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/equipments/${equipmentId}`, {withCredentials: true});
        return response.data.data.equipment;

    } catch (error) {
        throw error;
    }
}

export const updateEquipment = async (equipmentDTO: any, id: number) => {
    try{

        const response = await axios.put(`${API_BASE_URL}/equipments/${id}`, equipmentDTO , {withCredentials: true});
        return response.data.data.equipment;
    }
    catch(error){
        throw error;
    }
}